export default __webpack_public_path__ + "static/media/arrow-right.e3ca337a.svg";